import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-strangularlib',
  template: `
    <p>
      strangularlib works!
    </p>
  `,
  styles: [
  ]
})
export class StrangularlibComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
